var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentLoader,{tag:"component",on:{"on-seach":function($event){return _vm.$emit('on-search', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }